// public/js/features/assets/assets-state.js
// Central state for fast back navigation (in-memory cache)
export let assetsListCache = [];

export function setAssetsCache(assets) {
  assetsListCache = assets.map(a => ({ ...a })); // shallow clone reicht
}

export function getAssetsCache() {
  return assetsListCache;
}

export function updateAssetInCache(updatedAsset) {
  const idx = assetsListCache.findIndex(a => a.assetUUID === updatedAsset.assetUUID);
  if (idx > -1) {
    assetsListCache[idx] = { ...assetsListCache[idx], ...updatedAsset };
  }
}

export function clearAssetsCache() {
  assetsListCache = [];
}


export function removeAssetFromCache(assetUUID) {
  assetsListCache = assetsListCache.filter(a => a.assetUUID !== assetUUID);
}